// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D7hiq","question":"styles_question__32CxN","description":"styles_description__2L3bx"};